import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid2,
} from "@mui/material";
import React from "react";

const BuyerDashboard = ({ setDashboard }) => {
  const cards = [
    { title: "Service Order Approval", key: "SERVICE" },
    { title: "Invoice Approval", key: "INVOICE" },
    { title: "New Customer Approval", key: "CUSTOMER" },
    { title: "New Vendor Approval", key: "VENDOR_APPROVAL" },
    { title: "Trade Marketing Scheme", key: "TRADE" },
    { title: "Vendor Advance", key: "VENDOR_ADVANCE" },
    { title: "Customer Deposit", key: "CUSTOMER_DEPOSIT" },
    { title: "Tender Deposit", key: "TENDER_DEPOSIT" },
  ];

  const writeoff = [
    { title: "Vendor Balances", key: "VENDOR-Off" },
    { title: "Customer Balances", key: "CUSTOMER_BALANCE-Off" },
    { title: "Advances Given", key: "ADVANCE-Off" },
    { title: "Deposit Given", key: "DEPOSIT-Off" },
    { title: "Inventory", key: "INVENTORY-Off" },
    { title: "Others", key: "OTHER-Off" },
  ];

  const writeback = [
    { title: "Vendor Balances", key: "VENDOR-Back" },
    { title: "Customer Balances", key: "CUSTOMER_BALANCE-Back" },
    { title: "Advances Given", key: "ADVANCE-Back" },
    { title: "Deposit Given", key: "DEPOSIT-Back" },
    { title: "Inventory", key: "INVENTORY-Back" },
    { title: "Others", key: "OTHER-Back" },
  ];

  const handleCardClick = (key) => {
    localStorage.setItem("dashboard", JSON.stringify(key.split("-")[0]));
    if (key.includes("Off")) {
      localStorage.setItem("type", JSON.stringify("Off"));
    } else if (key.includes("Back")) {
      localStorage.setItem("type", JSON.stringify("Back"));
    }
    setDashboard(key.split("-")[0]);
    window.dispatchEvent(new Event("storage"));
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <h2>Welcome to the Nobel’s AMS</h2>
      <Grid2 container spacing={2} justifyContent="center" sx={{ mx: "auto" }}>
        {cards.map((card, index) => (
          <Grid2 size={{ xs: 12, sm: 3 }} key={index}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 3,
                "&:hover": { boxShadow: 6, transform: "scale(1.03)" },
                transition: "all 0.3s ease",
                minHeight: "100%",
              }}
            >
              <CardActionArea
                onClick={() => handleCardClick(card.key)}
              >
                <CardContent>
                  <Typography variant="h6" fontSize={"16px"} fontWeight="bold">
                    {card.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid2>
        ))}
      </Grid2>
      <Grid2 container spacing={2}>
        <Grid2
          size={{ xs: 12, sm: 6 }}
          sx={{
            border: "1px dashed #74d4fdff",
            borderRadius: "5px",
            px: 2,
            pb: 2,
            mt: 3,
          }}
        >
          <h2>Write Off</h2>
          <Grid2
            container
            spacing={2}
            justifyContent="center"
            sx={{ mx: "auto" }}
          >
            {writeoff.map((card, index) => (
              <Grid2 size={{ xs: 12, sm: 6 }} key={index}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    "&:hover": { boxShadow: 6, transform: "scale(1.03)" },
                    transition: "all 0.3s ease",
                    minHeight: "100%",
                  }}
                >
                  <CardActionArea
                    onClick={() => handleCardClick(card.key)}
                  >
                    <CardContent>
                      <Typography variant="h6" fontSize={"16px"} fontWeight="bold">
                        {card.title}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Grid2>
        <Grid2
          size={{ xs: 12, sm: 6 }}
          sx={{
            border: "1px dashed #74d4fdff",
            borderRadius: "5px",
            px: 2,
            pb: 2,
            mt: 3,
          }}
        >
          <h2>Write Back</h2>
          <Grid2
            container
            spacing={2}
            justifyContent="center"
            sx={{ mx: "auto" }}
          >
            {writeback.map((card, index) => (
              <Grid2 size={{ xs: 12, sm: 6 }} key={index}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    "&:hover": { boxShadow: 6, transform: "scale(1.03)" },
                    transition: "all 0.3s ease",
                    minHeight: "100%",
                  }}
                >
                  <CardActionArea
                    onClick={() => handleCardClick(card.key)}
                  >
                    <CardContent>
                      <Typography variant="h6" fontSize={"16px"} fontWeight="bold">
                        {card.title}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default BuyerDashboard;
